/**
 * * 오토메 작품 상세 정보 카드 섹션
 */
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/button/PrimaryButton';
import NoImage from 'components/etc/NoImage';
import { useCookies } from 'react-cookie';
import { IBubbleSet, ISupportLanguage } from 'utils/types/storyTypes';
import CollapseArrow from './CollapseArrow';
import { useAppDispatch } from 'hooks/redux';
import { setStoryName } from 'store/slices/breadcumbSlice';

interface IProps {
  [key: string]: any | undefined;
  onClick: () => void;
  bubbleSetList: IBubbleSet[] | undefined;
  supportLangList: ISupportLanguage[] | null;
}
const OtomeInformation: React.FC<IProps> = ({
  onClick,
  selectProject,
  bubbleSetList,
  supportLangList,
}) => {
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();
  const { t } = useTranslation();
  const [collapseShow, setCollapseShow] = useState(false);
  const onCollapse = (e) => {
    setCollapseShow(!collapseShow);
  };

  const titleTranslate = selectProject?.projectDetails?.find(
    (e) => e.lang === cookies.lang,
  );

  dispatch(
    setStoryName(titleTranslate ? titleTranslate?.title : selectProject?.title),
  );
  const findImageUrl = selectProject?.projectDetails?.find(
    (e) => e.lang === cookies.lang,
  );

  const findSummary = selectProject?.projectDetails?.find(
    (e) => e.lang === cookies.lang,
  );

  const defaultSummary = selectProject?.projectDetails?.find(
    (e) => e.lang === cookies.lang,
  );

  const bubbleSetName = bubbleSetList?.find(
    (e) => e.code === selectProject?.bubble_set_id,
  );

  const defaultLang = supportLangList?.find(
    (e) => e.code === selectProject?.default_lang,
  );

  const summaryText = findSummary
    ? findSummary?.summary
    : defaultSummary?.summary;

  const imageThumbnail = useMemo(() => {
    if (!findImageUrl) {
      if (
        selectProject?.icon_url === null ||
        selectProject?.icon_url === undefined ||
        selectProject?.icon_url === ''
      ) {
        return <NoImage height='128px' />;
      } else {
        return (
          <img
            src={selectProject?.icon_url}
            className='thumbnail-image'
            alt='thumbnail'
          />
        );
      }
    } else {
      if (
        findImageUrl?.icon_url === null ||
        findImageUrl?.icon_url === undefined ||
        findImageUrl?.icon_url === ''
      ) {
        return <NoImage height='128px' />;
      }
      return (
        <img
          src={findImageUrl?.icon_url}
          className='thumbnail-image'
          alt='thumbnail'
        />
      );
    }
  }, [selectProject, findImageUrl]);
  return (
    <Container collapsed={collapseShow}>
      <Contents collapsed={collapseShow}>
        {collapseShow ? (
          <>
            <ContentWrapper>
              <ThumbnailWrapper>{imageThumbnail}</ThumbnailWrapper>
              <ContentInforWrapper>
                <p className='title'>
                  {titleTranslate
                    ? titleTranslate?.title
                    : selectProject?.title}
                </p>
                <p className='desc'>
                  {summaryText
                    ? summaryText
                    : '프로젝트 설명글이 들어오는 자리 입니다. **현재 데이터 입력되지 않음'}
                </p>
                <InforWrapper>
                  <div>
                    <p className='label'>
                      {t(
                        'storyEpisodeID.storyTabMenuList.episodeContent.banner.status',
                      )}
                    </p>
                    <p className='label'>
                      {t(
                        'storyEpisodeID.storyTabMenuList.episodeContent.banner.speechBubble',
                      )}
                    </p>
                    <p className='label'>
                      {t(
                        'storyEpisodeID.storyTabMenuList.episodeContent.banner.defaultLanguage',
                      )}
                    </p>
                  </div>
                  <div>
                    <p className='infor'>{selectProject?.project_state}</p>
                    <p className='infor'>{bubbleSetName?.code_name}</p>
                    <p className='infor'>{defaultLang?.code_name}</p>
                  </div>
                  <div>
                    <p className='label'>클라이언트 ID</p>
                    <p className='label'>스토어 ID</p>
                  </div>
                  <div>
                    <p className='infor'>
                      {selectProject?.produce_package_id
                        ? selectProject.produce_package_id
                        : '런칭시점에 설정'}
                    </p>
                    <p className='infor'>
                      {selectProject?.bundle_id
                        ? selectProject.bundle_id
                        : '런칭시점에 설정'}
                    </p>
                  </div>
                </InforWrapper>
              </ContentInforWrapper>
              <BtnWrapper>
                <PrimaryButton
                  text={t('storyEpisodeID.header.editWorkInformation')}
                  height='40px'
                  width='100%'
                  bgColor={theme.colors.blue_500}
                  textColor='#ffffff'
                  fontWeight={theme.fontWeights.medium}
                  fontSize={theme.fontSizes.normal}
                  border={`1px solid ${theme.colors.blue_500}`}
                  rounded='6px'
                  hoverBgColor={theme.colors.blue_600}
                  activeBgColor={theme.colors.blue_800}
                  selectedBgColor={theme.colors.blue_700}
                  onClick={onClick}
                />
              </BtnWrapper>
            </ContentWrapper>
            <div className='collpaseArrWrapper'>
              <CollapseArrow onClick={onCollapse} collapseShow={collapseShow} />
            </div>
          </>
        ) : (
          <>
            <CollpasedWrapper>
              <div className='left-wrap'>
                <p className='title'>
                  {titleTranslate
                    ? titleTranslate?.title
                    : selectProject?.title}
                </p>
                <PrimaryButton
                  text={t('storyEpisodeID.header.editWorkInformation')}
                  height='40px'
                  width='fit-content'
                  bgColor={theme.colors.blue_500}
                  textColor='#ffffff'
                  fontWeight={theme.fontWeights.medium}
                  fontSize={theme.fontSizes.normal}
                  border={`1px solid ${theme.colors.blue_500}`}
                  rounded='6px'
                  hoverBgColor={theme.colors.blue_600}
                  activeBgColor={theme.colors.blue_800}
                  selectedBgColor={theme.colors.blue_700}
                  onClick={onClick}
                />
              </div>
              <CollapseArrow onClick={onCollapse} collapseShow={collapseShow} />
            </CollpasedWrapper>
          </>
        )}
      </Contents>
    </Container>
  );
};

export default OtomeInformation;

const Container = styled.div`
  background-color: ${theme.colors.blue_50};
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  border-radius: 1rem;
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 5%);
  /* height: 15rem; */
  position: relative;
  overflow: hidden;
  transition: all ease 2s 0s;
  .collpaseArrWrapper {
    display: flex;
    justify-content: end;
  }
  .title {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.xl};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 36px;
    letter-spacing: 0.1px;
  }
`;
const Contents = styled.div`
  height: auto;
  /* transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1); */
  transition: all ease 0.5s 0s;
  position: relative;
`;

const ContentWrapper = styled.div`
  display: flex;
  .editBtn {
    width: 30%;
  }
`;

const ThumbnailWrapper = styled.div`
  width: 128px;
  .thumbnail-image {
    height: 128px;
    width: 100%;
    object-fit: cover;
  }
`;

const ContentInforWrapper = styled.div`
  width: 75%;
  padding: 0 24px;
  .desc {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    word-break: keep-all;
    line-height: 24px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }
`;

const InforWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  .label {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .infor {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  & > * + * {
    margin-left: 24px;
  }
`;

const BtnWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const CollpasedWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-wrap {
    display: flex;
    & > * + * {
      margin-left: 24px;
    }
  }
`;
